module.exports = __webpack_public_path__ + "media/images/ui__warning--dark-f1ddb8d1f5ca881eed98fd9c97a9d511.png";